import { bookService } from '@/services'

import { firstTeamBook, secondTeamBook, thirdTeamBook, headquartersProjects } from '@/onboarding'

export default async (commit, settings, headquartersId) => {
  try {
    // CREATE FIRST SECTION
    await bookService.createSection('Teams')

    // CREATE FIRST BOOK
    await firstTeamBook(commit, settings)

    // CREATE SECOND BOOK
    await secondTeamBook(commit, settings)

    // CREATE SECOND SECTION
    await bookService.createSection('Projects')

    // CREATE THIRD BOOK
    await thirdTeamBook(commit, settings)

    // CREATE HEADQUARTERS FIRST PROJECT
    await headquartersProjects(headquartersId, settings)

    return Promise.resolve()
  } catch (err) {
    commit('loading', false)
    return Promise.reject(err)
  }
}
